import { useAppStatusStore } from "@/shared/stores/appStatusStore";

/**
 * Full-screen blocking overlay shown during deployment / maintenance.
 * Prevents all user interaction until the flag is cleared by the deploy script.
 */
export const MaintenanceBanner = () => {
  const message = useAppStatusStore((s) => s.maintenanceMessage);
  if (!message) return null;

  return (
    <div
      role="alert"
      aria-live="assertive"
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-black/70 backdrop-blur-sm"
    >
      <div className="rounded-2xl bg-amber-500 text-amber-950 px-8 py-6 shadow-2xl max-w-sm w-full mx-4 flex flex-col items-center gap-4 text-center">
        {/* Spinning indicator */}
        <svg
          className="w-10 h-10 animate-spin text-amber-800"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <circle
            className="opacity-25"
            cx="12" cy="12" r="10"
            stroke="currentColor" strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          />
        </svg>
        <p className="text-base font-semibold leading-snug">{message}</p>
        <p className="text-xs text-amber-800">
          The page will reload automatically when ready.
        </p>
      </div>
    </div>
  );
};
